/* ============================================================
   FEED PRIORITY (feed-priority.js) — BENTON'S HOME-FEED CONTROLS
   ------------------------------------------------------------
   FEED_P1 — the Priority 1 opener(s). Benton chooses these, and
   only Benton. The first id leads the feed; if more than one id
   is listed, each new cadence block leads with the next one
   until the list runs out. Change anytime (tell Claude, or edit
   the Placement column in the Content Registry sheet and say
   "sync").

   Home-feed cadence (Benton, 2026-09-11):
     P1 video → merch ad → 3 Priority-2 videos → (repeat:
     merch ad → 3 more P2s …) until content runs out.

   Priority 2 pool = clips popular on social media or showing
   Obed performing live: live-category clips, vertical hosted
   clips, and #Shorts — ranked by like count (social-popularity
   proxy) with Shopify-hosted clips winning ties over YouTube.
   ============================================================ */

/* NEW SINGLE — "I Don't Get High Anymore" (Benton, 2026-09-25):
   group-share guitar clip, ingested to the Shopify CDN. Defined
   here (not in feed-items.js) so the generated file stays a
   clean mirror of the Feed Script sheet; this push runs after
   feed-items.js loads and before feed.js reads FEED_ITEMS. */
FEED_ITEMS.push(
  {id: "h12", type: "video", category: "albums", album: "singles",
   hostedSrc: "https://cdn.shopify.com/videos/c/vp/f11fa0c927be4393a1d7851c324b06c2/f11fa0c927be4393a1d7851c324b06c2.HD-720p-4.5Mbps-95579431.mp4",
   hostedSrcHd: "https://cdn.shopify.com/videos/c/vp/f11fa0c927be4393a1d7851c324b06c2/f11fa0c927be4393a1d7851c324b06c2.HD-1080p-7.2Mbps-95579431.mp4",
   orientation: "vertical", duration: 39,
   title: "I Don't Get High Anymore",
   caption: "The new single. Out everywhere now.",
   tags: ["#IDontGetHighAnymore", "#NewMusic"], likes: 2800}
);

const FEED_P1 = [
  'h12',  // I Don't Get High Anymore — new single (Benton's pick, 2026-09-25)
  // 'h11' (BROWN$DOWN) rotated out of P1 — still in the feed; its
  // 12.4K likes put it at the top of the Priority-2 pool.
];

/* PRIORITY-2 HEAD OF LINE (from Obed's real social traction,
   checked on TikTok + Instagram 2026-09-14):
     · "There's 2 types of Mexicans" — 1.5M views / 256K likes on
       TikTok (plus a 443K pt. 2); his biggest owned music post
     · Rodeo Clown — the current era: all 3 Instagram pins are
       Rodeo Clown (EP announcement, title-track release video)
     · Brown & Down — 1.2M TikTok views + IG pin at 47.5K likes
   (The two 20M+ TikToks are Funyuns/Flamin' Hot paid-partnership
   ads — brand content, not for the site.)
   These ids jump the P2 queue in this order; everything after
   them still ranks by likes.                                   */
const FEED_P2_FIRST = [
  'sh3',    // There's 2 types of Mexicans (Short)
  'a-rc1',  // RODEO CLOWN — Official Video
  'sh7',    // From Brown & Down to Rodeo Clown (Short)
  'sh1',    // The Rodeo Clown — Short
];
